import { render, staticRenderFns } from "./Tabs.vue?vue&type=template&id=7ec61de0&scoped=true&"
import script from "./Tabs.vue?vue&type=script&lang=js&"
export * from "./Tabs.vue?vue&type=script&lang=js&"
import style0 from "./Tabs.vue?vue&type=style&index=0&id=7ec61de0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec61de0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ec61de0')) {
      api.createRecord('7ec61de0', component.options)
    } else {
      api.reload('7ec61de0', component.options)
    }
    module.hot.accept("./Tabs.vue?vue&type=template&id=7ec61de0&scoped=true&", function () {
      api.rerender('7ec61de0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/index/components/Tabs.vue"
export default component.exports